export default __webpack_public_path__ + "static/media/warning--tunnel--g5.598ceb68.png";